import React from 'react';
import { Clock, PencilSimple, Plus } from '@phosphor-icons/react';

/*
 * iter132.2 — Payment Terms audit timeline. Compact vertical list of
 * created + edited events on the Won lead's structured payment terms.
 * Consumes `payment_terms_history` from GET /leads/{id}/payment-schedule.
 */

const fmtWhen = (iso) => {
  try {
    return new Date(iso).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso || '—';
  }
};

export default function PaymentTermsTimeline({ history }) {
  if (!history || history.length === 0) return null;
  // Newest first — history is appended chronologically.
  const rows = [...history].reverse();
  return (
    <div className="medical-card p-5 mb-6" data-testid="payment-terms-timeline">
      <h3 className="text-lg font-semibold text-[#052A23] flex items-center gap-2 mb-1" style={{ fontFamily: 'Outfit' }}>
        <Clock size={20} /> Payment Terms History
      </h3>
      <p className="text-xs text-[#6D8E87] mb-4">
        Every change to the structured payment terms on this lead, newest at the top.
      </p>
      <ol className="relative border-l-2 border-[#D5E8E4] ml-2 pl-4 space-y-4">
        {rows.map((h, i) => {
          const isCreated = h.event === 'created' || !h.previous_summary;
          const Icon = isCreated ? Plus : PencilSimple;
          return (
            <li key={`${h.at}-${i}`} className="relative" data-testid={`terms-timeline-item-${i}`}>
              <span
                className={`absolute -left-[26px] top-0.5 grid place-items-center w-5 h-5 rounded-full text-white ${
                  isCreated ? 'bg-emerald-600' : 'bg-sky-600'
                }`}
                aria-hidden="true"
              >
                <Icon size={12} weight="bold" />
              </span>
              <div className="text-xs text-[#6D8E87]">{fmtWhen(h.at)} · {h.by_name || 'System'}</div>
              <div className="text-sm text-[#052A23]">
                {isCreated ? (
                  <>
                    <span className="font-semibold text-emerald-700">Terms set at Won</span>
                    {h.new_summary && <>: {h.new_summary}</>}
                  </>
                ) : (
                  <>
                    <span className="font-semibold text-sky-700">Terms edited</span>
                    {h.previous_summary && (
                      <>: <span className="line-through text-[#6D8E87]">{h.previous_summary}</span></>
                    )}
                    {h.new_summary && <> → <span className="font-medium">{h.new_summary}</span></>}
                  </>
                )}
              </div>
              {h.reason && (
                <div className="text-[11px] text-[#3B5A54] italic mt-0.5">
                  “{h.reason}”
                </div>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
